import { createIcon } from '@chakra-ui/react';

export const MbeCheck = createIcon({
  displayName: 'MbeCheck',
  viewBox: '0 0 64 64',
  path: (
    <path
      d="M27.6 42.021c-.342 0-.67-.136-.91-.377l-8.668-8.667a1.287 1.287 0 1 1 1.82-1.82l7.757 7.757 16.56-16.559a1.287 1.287 0 0 1 1.82 1.82l-17.47 17.47a1.287 1.287 0 0 1-.91.376"
      fill="currentColor"
    />
  ),
});
